module.exports = __webpack_public_path__ + "img/donation-prep-9.69f7d37b.png";